// import React, { useState } from "react";

// const FeedbackPage = () => {
//   const [form, setForm] = useState({ name: "", email: "", message: "" });

//   const handleChange = (e) => {
//     setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     alert(" Thank you for your feedback!");
//     setForm({ name: "", email: "", message: "" });
//   };

//   return (
//     <div className="max-w-3xl mx-auto p-6">
//       <h1 className="text-2xl font-semibold mb-6">Site Feedback</h1>
//       <form onSubmit={handleSubmit} className="space-y-4">
//         <input
//           name="name"
//           value={form.name}
//           onChange={handleChange}
//           placeholder="Your Name"
//           className="w-full p-3 border rounded"
//         />
//         <input
//           name="email"
//           value={form.email}
//           onChange={handleChange}
//           placeholder="Your Email"
//           type="email"
//           className="w-full p-3 border rounded"
//         />
//         <textarea
//           name="message"
//           value={form.message}
//           onChange={handleChange}
//           placeholder="Your Feedback"
//           rows="5"
//           className="w-full p-3 border rounded"
//         />
//         <button
//           type="submit"
//           className="bg-black text-white py-3 px-6 rounded hover:bg-gray-800"
//         >
//           Submit Feedback
//         </button>
//       </form>
//     </div>
//   );
// };

// export default FeedbackPage;

import React, { useState } from "react";
import { Link } from "react-router-dom";

const FeedbackPage = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setForm({ name: "", email: "", message: "" });
  };

  return (
    <div className="max-w-3xl mx-auto p-6 min-h-[400px]">
      <h1 className="text-2xl font-semibold mb-6">Site Feedback</h1>

      {submitted ? (
        <div className="space-y-4 text-center">
          <p className="text-green-600 font-medium text-lg">
            We’ve received your feedback!
          </p>
          <Link
            to="/"
            className="inline-block mt-4 px-6 py-2 bg-black text-white rounded hover:bg-gray-800"
          >
            Continue Shopping
          </Link>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            name="name"
            value={form.name}
            onChange={handleChange}
            placeholder="Your Name"
            className="w-full p-3 border rounded"
            required
          />
          <input
            name="email"
            type="email"
            value={form.email}
            onChange={handleChange}
            placeholder="Your Email"
            className="w-full p-3 border rounded"
            required
          />
          <textarea
            name="message"
            value={form.message}
            onChange={handleChange}
            placeholder="Your Feedback"
            rows="5"
            className="w-full p-3 border rounded"
            required
          />
          <button
            type="submit"
            className="bg-black text-white py-3 px-6 rounded hover:bg-gray-800"
          >
            Submit Feedback
          </button>
        </form>
      )}
    </div>
  );
};

export default FeedbackPage;
